var _effectorFileName = "/builds/gmini/front-ui-kit/src/Checkbox/Checkbox.tsx";

/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from 'react';
import { hexToRgba } from '@gmini/utils';
import { Square, FillSquareMinus, Checked } from '../icons';
import { CheckboxContainer, HiddenCheckbox, CheckboxIconWrapper } from './Checkbox.styled';
import { defaultCheckboxColors } from './defaultCheckboxColors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Checkbox = /*#__PURE__*/React.memo(({
  className,
  checked,
  indeterminate,
  onClick,
  hover,
  ...props
}) => {
  const colors = useMemo(() => ({ ...defaultCheckboxColors,
    ...props.colors
  }), [props.colors]);
  const icon = useMemo(() => {
    if (indeterminate) {
      return /*#__PURE__*/_jsx(FillSquareMinus, {
        color: props.disabled ? hexToRgba(colors.indeterminateDisabled, 0.25) : hexToRgba(colors.indeterminate, 1)
      });
    }

    if (checked) {
      return /*#__PURE__*/_jsx(Checked, {
        color: props.disabled ? hexToRgba(colors.checkedDisabled, 0.25) : hexToRgba(colors.checked, 1)
      });
    }

    return /*#__PURE__*/_jsx(Square, {
      color: props.disabled ? hexToRgba(colors.unCheckedDisabled, 0.15) : hexToRgba(colors.unChecked, 0.35)
    });
  }, [checked, colors.checked, colors.checkedDisabled, colors.indeterminate, colors.indeterminateDisabled, colors.unChecked, colors.unCheckedDisabled, indeterminate, props.disabled]);
  return /*#__PURE__*/_jsxs(CheckboxContainer, {
    "data-test-id": "checkbox",
    onClick: onClick,
    className: className,
    disabled: props.disabled,
    hover: hover,
    hoverColor: colors.hoverColor,
    children: [/*#__PURE__*/_jsx(HiddenCheckbox, {
      checked: checked,
      readOnly: true,
      ...props
    }), /*#__PURE__*/_jsx(CheckboxIconWrapper, {
      children: icon
    })]
  });
});
Checkbox.displayName = 'Checkbox';